import React from 'react'
import { useMapEvents } from 'react-leaflet'

type Props = {
  handleClick?: () => void
  handleOver?: () => void
}

const MapEvents: React.FC<Props> = (props) => {
  useMapEvents({
    click: () => props.handleClick && props.handleClick(),
    mouseover: () => props.handleOver && props.handleOver(),
  })
  return null
}

export default React.memo(MapEvents)
